import { R } from "../constants/resources";
import { getAbsolute, MAIN_ROUTES } from "../constants/routes";
import { hasAccess } from "./Permissions";

export const navigations = [
  { icon: R.ic_dashboard, text: "Dashboard", route: MAIN_ROUTES.DASHBOARD },
  {
    icon: R.ic_rto_services,
    text: "Services",
    route: MAIN_ROUTES.RTO_SERVICES.ROUTE,
    submenu: [
      {
        tag: "Vehicle Services",
        icon: R.ic_vahan_check,
        text: "Vahan Check",
        module: "Vahan Check",
        route: getAbsolute(MAIN_ROUTES.RTO_SERVICES.VAHAN_CHECK),
      },
      {
        tag: "Vehicle Services",
        icon: R.ic_rto_challan,
        text: "Challan Check",
        module: "Challan Check",
        route: getAbsolute(MAIN_ROUTES.RTO_SERVICES.CHALLAN),
      },
      {
        tag: "Vehicle Services",
        icon: R.ic_service_history,
        text: "Service History",
        module: "Service History",
        route: getAbsolute(MAIN_ROUTES.SERVICE_HISTORY.SERVICE_LIST),
      },
      {
        tag: "Vehicle Services",
        icon: R.ic_service_history,
        text: "Vehicle Crime Report",
        module: "Vehicle Crime Report",
        route: getAbsolute(MAIN_ROUTES.VEHICLE_CRIME.VEHICLE_CRIME_LIST),
      },
      {
        tag: "Consultancy",
        icon: R.ic_rto_cases,
        text: "RTO Consultancy",
        module: "RTO Consultancy",
        route: getAbsolute(MAIN_ROUTES.RTO_SERVICES.RTO_CASES),
      },
      {
        tag: "Delivery",
        icon: R.ic_rto_pickup,
        text: "Door Service",
        module: "Door Service",
        route: getAbsolute(MAIN_ROUTES.RTO_SERVICES.PICKUP_REQUEST),
      },
      {
        tag: "Media",
        icon: R.ic_camera,
        text: "Photoshoot Service",
        module: "Photoshoot Service",
        route: getAbsolute(MAIN_ROUTES.RTO_SERVICES.PHOTO_SHOOT),
      },
      {
        tag: "Media",
        icon: R.ic_camera,
        text: "Creative Designing",
        module: "Creative Designing",
        route: getAbsolute(MAIN_ROUTES.RTO_SERVICES.CREATIVE_MAKING),
      },
      {
        tag: "Media",
        icon: R.ic_advertising,
        text: "Social Media",
        module: "Social Media",
        route: getAbsolute(MAIN_ROUTES.RTO_SERVICES.SOCIAL_MEDIA),
      },
      {
        tag: "Media",
        icon: R.ic_digital_marketing,
        text: "Digital Marketing",
        module: "Digital Marketing",
        route: getAbsolute(MAIN_ROUTES.RTO_SERVICES.DIGITAL_MARKETING),
      },
      {
        tag: "Media",
        icon: R.ic_website_development,
        text: "Website Development",
        module: "Website Development",
        route: getAbsolute(MAIN_ROUTES.RTO_SERVICES.WEBSITE_DEVELOPMENT),
      },
      {
        tag: "Auction",
        icon: R.ic_d2d,
        text: "D2D Auction",
        module: "Auction Services",
        route: getAbsolute(MAIN_ROUTES.RTO_SERVICES.D2D_AUCTION),
      },
      {
        tag: "Auction",
        icon: R.ic_d2d,
        text: "D2D Requirement",
        module: "Auctions Requirement",
        route: getAbsolute(MAIN_ROUTES.RTO_SERVICES.D2D_REQUIREMENT),
      },
      {
        tag: "Auction",
        icon: R.ic_d2d,
        text: "Dealer Reels",
        module: "Dealer Reels",
        route: getAbsolute(MAIN_ROUTES.RTO_SERVICES.VIEW_DEALER_USER_REELS),
      },
      {
        tag: "Auction",
        icon: R.ic_d2d,
        text: "Classified Listing",
        module: "Classified Listing",
        route: getAbsolute(MAIN_ROUTES.RTO_SERVICES.CLASSIFIED_LISTING),
      },
    ],
  },
  {
    icon: R.ic_dealers,
    text: "Dealers",
    route: MAIN_ROUTES.DEALER_MANAGEMENT.ROUTE,
    submenu: [
      {
        icon: R.ic_dealers,
        text: "Dealer List",
        module: "Dealer List",
        route: getAbsolute(MAIN_ROUTES.DEALER_MANAGEMENT.DEALERS),
      },
      {
        icon: R.ic_dealers,
        text: "Dealer Payments",
        module: "Dealer Payments",
        route: getAbsolute(MAIN_ROUTES.DEALER_MANAGEMENT.DEALER_SUBSCRIPTION),
      },
      {
        icon: R.ic_notification,
        text: "Notification",
        module: "Notification",
        route: getAbsolute(MAIN_ROUTES.DEALER_MANAGEMENT.NOTIFICATION),
      },
      {
        icon: R.ic_rto_services,
        text: "Call Log Dashboard",
        module: "Call Log Dashboard",
        route: getAbsolute(MAIN_ROUTES.DEALER_MANAGEMENT.CALL_LOG_DASHBOARD),
      },
    ],
  },
  {
    icon: R.ic_master_management,
    text: "Masters",
    route: MAIN_ROUTES.MASTER_MANAGEMENT.ROUTE,
    submenu: [
      {
        icon: R.ic_user_list,
        text: "Users",
        module: "User",
        route: getAbsolute(MAIN_ROUTES.MASTER_MANAGEMENT.USERS),
      },
      {
        icon: R.ic_role_list,
        text: "Roles",
        module: "Roles",
        route: getAbsolute(MAIN_ROUTES.MASTER_MANAGEMENT.ROLES),
      },
    ],
  },
  {
    icon: R.ic_rto_services,
    text: "Transaction",
    route: MAIN_ROUTES.TRANSACTIONS.ROUTE,
    submenu: [
      {
        icon: R.ic_rto_challan,
        text: "Service Transaction",
        module: "Service Transaction",
        route: getAbsolute(MAIN_ROUTES.TRANSACTIONS.SERVICE_TRANSACTION),
      },
      {
        icon: R.ic_rto_pickup,
        text: "Bank Transaction",
        module: "Bank Transaction",
        route: getAbsolute(MAIN_ROUTES.TRANSACTIONS.BANK_TRANSACTION),
      },
      {
        icon: R.ic_rto_cases,
        text: "Outstanding Transaction",
        module: "Outstanding Transaction",
        route: getAbsolute(MAIN_ROUTES.TRANSACTIONS.OUTSTANDING_TRANSACTION),
      },
    ],
  },
  {
    icon: R.ic_rto_services,
    text: "Inventory",
    route: MAIN_ROUTES.INVENTORY.ROUTE,
    submenu: [
      {
        icon: R.ic_rto_services,
        text: "Inventory Management",
        module: "Inventory Management",
        route: getAbsolute(MAIN_ROUTES.INVENTORY.INVENTORY_LIST),
      },
    ],
  },
  {
    icon: R.ic_financial_services,
    text: "Financial Services",
    route: MAIN_ROUTES.FINANCIALSERVICES.ROUTE,
    submenu: [
      {
        icon: R.ic_loans,
        text: "Customer Loans",
        module: "Customer Loans",
        route: getAbsolute(MAIN_ROUTES.FINANCIALSERVICES.LOANS_LIST),
      },
      {
        icon: R.ic_loan_insurance,
        text: "Customer Insurance",
        module: "Customer Insurance",
        route: getAbsolute(MAIN_ROUTES.FINANCIALSERVICES.INSURANCE_LIST),
      },
    ],
  },
  {
    icon: R.ic_rto_services,
    text: "Lead",
    route: MAIN_ROUTES.LEAD.ROUTE,
    submenu: [
      {
        icon: R.ic_rto_services,
        text: "Upload Buyer Lead",
        module: "Upload Buyer Lead",
        route: getAbsolute(MAIN_ROUTES.LEAD.LEAD_LIST),
      },
      {
        icon: R.ic_user_list,
        text: "Customer Management",
        module: "Customer Management",
        route: getAbsolute(MAIN_ROUTES.LEAD.CUSTOMER_LEAD),
      },
    ],
  },
  {
    icon: R.ic_dealers,
    text: "About",
    route: MAIN_ROUTES.PRIVACY_POLICY.ROUTE,
    submenu: [
      {
        icon: R.ic_privacy_policy,
        text: "Privacy Policy",
        module: "Privacy Policy",
        route: MAIN_ROUTES.PRIVACY_POLICY,
      },
      {
        icon: R.ic_terms_conditions,
        text: "Terms & Conditions",
        // Real API sub_module_name is "Term & Conditions" (singular "Term").
        module: "Term & Conditions",
        route: MAIN_ROUTES.TERMS_CONDITIONS,
      },
    ],
  },
  {
    icon: R.ic_dealers,
    text: "CMS",
    route: MAIN_ROUTES.CONTENT_MANAGEMENT.ROUTE,
    submenu: [
      {
        icon: R.ic_privacy_policy,
        text: "Manage Services",
        module: "Manage Services",
        route:
          MAIN_ROUTES.CONTENT_MANAGEMENT.ROUTE +
          "/" +
          MAIN_ROUTES.CONTENT_MANAGEMENT.CONTENT_LIST,
      },
    ],
  },
];

/* Dashboard is the sole exception: the get-user API always includes it
   (with an empty `submodules` array) for every role, so it needs no
   explicit permission check. Every other entry must declare a `module`
   that matches a real API submodule name — an item with no `module` (or
   one hasAccess() can't find in the role's permissions) is hidden rather
   than shown by default. */
const isItemVisible = (item) =>
  item.route === MAIN_ROUTES.DASHBOARD || (!!item.module && hasAccess(item.module));

export const getVisibleNavigations = () =>
  navigations
    .map((nav) => {
      if (!nav.submenu) return isItemVisible(nav) ? nav : null;
      const visibleSub = nav.submenu.filter(isItemVisible);
      if (visibleSub.length === 0) return null;
      return { ...nav, submenu: visibleSub };
    })
    .filter(Boolean);

/* First route the current role can actually see in the sidebar — the first
   submenu item of the first visible section, or that section's own route if
   it has no submenu (e.g. Dashboard). Used as a permission-aware fallback
   instead of a hardcoded default route the role might not have access to. */
export const getFirstAccessibleRoute = () => {
  const visible = getVisibleNavigations();
  const first = visible[0];
  if (!first) return null;
  return first.submenu?.[0]?.route || first.route || null;
};

/* Same idea, scoped to a single sidebar section by its nav `text` (e.g.
   "Services") — first accessible submenu item within that section. */
export const getFirstAccessibleRouteInSection = (sectionText) => {
  const visible = getVisibleNavigations();
  const section = visible.find((nav) => nav.text === sectionText);
  return section?.submenu?.[0]?.route || null;
};

export const get_url_extension = (url) => {
  return url?.split(/[#?]/)[0].split(".").pop().trim();
};

export const downloadFile = async (url, extension) => {
  const response = await fetch(url, { mode: "no-cors" });
  const blob = await response.blob();
  const fileUri = URL.createObjectURL(blob);

  const anchor = document.createElement("a");
  anchor.href = fileUri;
  anchor.target = "_blank";
  anchor.download = `file.${extension}`;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
};

export const isImage = (extension) =>
  ["png", "jpeg", "jpg", "gif"].includes(extension);

export const isCsv = (extension) => ["csv"].includes(extension);

// Generate service amount through agreed price
// export const generateServicePrice = (data = {}) => {
//   const base_consultancy_calc_factor = 1.18;
//   const gst_calc_factor = 0.18;

//   const { agreed_amount, amount, isGst } = data;

//   // Check required validation
//   if (!(agreed_amount && amount && parseInt(agreed_amount) > parseInt(amount)))
//     return {
//       consultancy: 0,
//       base_consultancy: 0,
//       gst_amount: 0,
//       total_amount: 0,
//     };

//   const consultancy = agreed_amount - amount;
//   const base_consultancy =
//     isGst === "GST_Included"
//       ? Math.ceil(consultancy / base_consultancy_calc_factor)
//       : Math.ceil(consultancy);
//   const gst_amount =
//     isGst === "GST_Not_Applicable"
//       ? 0
//       : Math.ceil(base_consultancy * gst_calc_factor);
//   const total_amount = Math.ceil(
//     parseInt(amount) + parseInt(base_consultancy) + parseInt(gst_amount)
//   );

//   return {
//     consultancy,
//     base_consultancy,
//     gst_amount,
//     total_amount,
//   };
// };

export const generateServicePrice = (data = {}) => {
  const base_consultancy_calc_factor = 1.18;
  const gst_calc_factor = 0.18;

  const { agreed_amount, amount = 0, isGst } = data;

  // Check required validation
  if (!(agreed_amount && parseInt(agreed_amount) >= parseInt(amount)))
    return {
      consultancy: 0,
      base_consultancy: 0,
      gst_amount: 0,
      total_amount: 0,
    };

  const consultancy = agreed_amount - amount;
  const base_consultancy =
    isGst === "GST_Included"
      ? consultancy / base_consultancy_calc_factor
      : consultancy;
  const gst_amount =
    isGst === "GST_Not_Applicable" ? 0 : base_consultancy * gst_calc_factor;
  const total_amount =
    parseFloat(amount) + parseFloat(base_consultancy) + parseFloat(gst_amount);

  return {
    consultancy,
    base_consultancy: parseFloat(base_consultancy.toFixed(2)),
    gst_amount: parseFloat(gst_amount.toFixed(2)),
    total_amount: parseFloat(total_amount.toFixed(2)),
  };
};

export const generateCreativePrice = (data = {}) => {
  const gst_calc_factor = 0.18;
  const base_consultancy_calc_factor = 1.18;

  const { agreed_amount, isGst } = data;

  // Check required validation
  const base_consultancy =
    isGst === "GST_Included"
      ? agreed_amount / base_consultancy_calc_factor
      : agreed_amount;
  const gst_amount =
    isGst === "GST_Not_Applicable" ? 0 : base_consultancy * gst_calc_factor;
  const total_amount =
    isGst === "GST_Included"
      ? parseFloat(agreed_amount)
      : parseFloat(agreed_amount) + parseFloat(gst_amount);

  return {
    agreed_amount,
    gst_amount: parseFloat(gst_amount.toFixed(2)),
    total_amount: parseFloat(total_amount.toFixed(2)),
  };
};

export const calculateTotalAmount = (data = {}) => {
  const gst_calc_factor = 0.18;
  const { agreed_amount, gst_type } = data;

  if (!agreed_amount) {
    return {
      total_amount: 0,
    };
  }

  let total_amount = 0;

  if (gst_type === "GST_Included") {
    total_amount = agreed_amount;
  } else if (gst_type === "GST_Excluded") {
    total_amount = agreed_amount * (1 + gst_calc_factor);
  } else if (gst_type === "GST_Not_Applicable") {
    total_amount = agreed_amount;
  }

  return {
    total_amount: parseFloat(total_amount),
  };
};

export const formatIndianCurrency = (amount) => {
  if (!amount) return "";

  const x = amount.toString().replace(/\D/g, "");

  const lastThree = x.substring(x.length - 3);
  const otherNumbers = x.substring(0, x.length - 3);

  const formattedValue =
    otherNumbers !== ""
      ? otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree
      : lastThree;

  return formattedValue;
};

const NUMBER_WORDS_ONES = [
  "",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "ten",
  "eleven",
  "twelve",
  "thirteen",
  "fourteen",
  "fifteen",
  "sixteen",
  "seventeen",
  "eighteen",
  "nineteen",
];

const NUMBER_WORDS_TENS = [
  "",
  "",
  "twenty",
  "thirty",
  "forty",
  "fifty",
  "sixty",
  "seventy",
  "eighty",
  "ninety",
];

const convertBelowThousandToWords = (num) => {
  const parts = [];
  let n = num;

  if (n >= 100) {
    parts.push(`${NUMBER_WORDS_ONES[Math.floor(n / 100)]} hundred`);
    n %= 100;
  }

  if (n >= 20) {
    const remainder = n % 10;
    const tensWord = NUMBER_WORDS_TENS[Math.floor(n / 10)];
    parts.push(remainder > 0 ? `${tensWord} ${NUMBER_WORDS_ONES[remainder]}` : tensWord);
  } else if (n > 0) {
    parts.push(NUMBER_WORDS_ONES[n]);
  }

  return parts.join(" ");
};

// Indian numbering system (Crore/Lakh/Thousand/Hundred) — matches
// formatIndianCurrency's grouping. Returns "" for zero/invalid/negative input.
export const convertAmountToWords = (amount) => {
  const num = Number(amount);
  if (!Number.isFinite(num) || num <= 0) return "";

  let n = Math.floor(num);

  const crore = Math.floor(n / 10000000);
  n %= 10000000;
  const lakh = Math.floor(n / 100000);
  n %= 100000;
  const thousand = Math.floor(n / 1000);
  n %= 1000;
  const rest = n;

  const segments = [];
  if (crore > 0) segments.push(`${convertBelowThousandToWords(crore)} crore`);
  if (lakh > 0) segments.push(`${convertBelowThousandToWords(lakh)} lakh`);
  if (thousand > 0)
    segments.push(`${convertBelowThousandToWords(thousand)} thousand`);
  if (rest > 0) segments.push(convertBelowThousandToWords(rest));

  const sentence = segments.join(" ").trim();
  return sentence ? capitalize(sentence) : "";
};

export const capitalizeEachWord = (sentence) => {
  if (!sentence) return "";
  return sentence
    .split(" ") // Split the sentence into an array of words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
    .join(" "); // Join the words back into a sentence
};

export function capitalize(s) {
  return s && String(s[0]).toUpperCase() + String(s).slice(1).toLowerCase();
}

export const STATUS_STYLES = {
  requested: {
    bg: "#FBF5DC",
    color: "#DCA100",
    label: "Requested",
  },

  approved: {
    bg: "#e3f2fd",
    color: "#1565c0",
    label: "Approved",
  },

  live: {
    bg: "#e6ffd9",
    color: "#2e7d32",
    label: "Live",
  },

  ended: {
    bg: "#ffe3e1",
    color: "#c62828",
    label: "Ended",
  },

  closed: {
    bg: "#f3e5f5",
    color: "#6a1b9a",
    label: "Closed",
  },

  cancelled: {
    bg: "#eeeeee",
    color: "#616161",
    label: "Cancelled",
  },

  // active: {
  //   bg: "#e6ffd9",
  //   color: "#2e7d32",
  //   label: "Active",
  // },

  won: {
    bg: "#e8f5e9",
    color: "#1b5e20",
    label: "Won",
  },
  // win: { bg: "#e8f5e9", color: "#1b5e20", label: "Win" },
};

export const STATUS_ACTIONS = {
  requested: {
    start: true,
    cancel: true,
    restart: false,
    rebid: false,
    reAuction: false,
    edit: true,
  },

  approved: {
    start: false,
    cancel: true,
    restart: false,
    rebid: false,
    reAuction: false,
    edit: true,
  },

  active: {
    start: false,
    cancel: true,
    restart: false,
    rebid: false,
    reAuction: false,
    edit: false,
  },

  live: {
    start: false,
    cancel: true,
    restart: false,
    rebid: false,
    reAuction: false,
    edit: false,
  },

  ended: {
    start: false,
    cancel: false,
    restart: true,
    rebid: true,
    reAuction: true,
    edit: false,
  },

  closed: {
    start: false,
    cancel: false,
    restart: false,
    rebid: false,
    reAuction: false,
    edit: false,
  },

  cancelled: {
    start: false,
    cancel: false,
    restart: false,
    rebid: false,
    reAuction: false,
    edit: false,
  },

  won: {
    start: false,
    cancel: false,
    restart: false,
    rebid: false,
    reAuction: false,
    edit: false,
  },
};

const DEFAULT_ACTIONS = {
  start: false,
  cancel: false,
  restart: false,
  rebid: true,
  reAuction: false,
  edit: true,
};

export const getStatusStyle = (status) =>
  STATUS_STYLES[status] || {
    bg: "#eeeeee",
    color: "#424242",
    label: "Unknown",
  };

// Shared color families for the generic `StatusBadge` component
// (components/Common/StatusBadge). Every list page's status/response column
// should resolve to one of these six tones instead of inventing its own —
// hex values reused from the D2D Auction status pill (requested/approved/
// live/ended/closed/cancelled) so the auction table stays the visual anchor.
const STATUS_THEME_FAMILIES = {
  green: { bg: "#E6FFD9", color: "#2D7D15", dot: "#43C702" },
  blue: { bg: "#E3F2FD", color: "#1565C0", dot: "#1565C0" },
  amber: { bg: "#FBF5DC", color: "#DCA100", dot: "#DCA100" },
  red: { bg: "#FFE3E1", color: "#C0392B", dot: "#F23030" },
  purple: { bg: "#F3E5F5", color: "#6A1B9A", dot: "#6A1B9A" },
  gray: { bg: "#EEEEEE", color: "#616161", dot: "#9599A3" },
};

// Exact-match lookup (lowercased) for the status strings actually seen
// across the app's list pages. Anything not listed here falls through to
// the keyword rules below instead of defaulting straight to gray.
const STATUS_THEME_EXACT = {
  active: "green",
  live: "green",
  completed: "green",
  done: "green",
  submitted: "green",
  processed: "green",
  paid: "green",
  full: "green",
  success: "green",
  won: "green",
  approved: "blue",
  requested: "amber",
  pending: "amber",
  "in progress": "amber",
  processing: "amber",
  "partial received": "amber",
  "follow-up": "amber",
  "follow up": "amber",
  new: "amber",
  closed: "purple",
  cancelled: "gray",
  canceled: "gray",
  deleted: "gray",
  draft: "gray",
  inactive: "red",
  rejected: "red",
  denied: "red",
  failed: "red",
  expired: "red",
  ended: "red",
  blacklist: "red",
  "not received": "red",
};

// Fallback keyword rules for status strings that don't hit the exact table
// above (API values are inconsistently worded across services). Checked in
// order, first match wins.
const STATUS_THEME_KEYWORD_RULES = [
  { family: "red", keywords: ["reject", "fail", "inactive", "expire", "blacklist", "denied", "ended", "not received"] },
  { family: "amber", keywords: ["pending", "request", "progress", "partial", "follow", "new"] },
  { family: "blue", keywords: ["approve"] },
  { family: "purple", keywords: ["close"] },
  { family: "gray", keywords: ["cancel", "delete", "draft"] },
  { family: "green", keywords: ["active", "complete", "done", "submit", "process", "paid", "success", "live", "won", "full"] },
];

// Standard "Title Case" formatter — lowercases the whole string first, then
// capitalizes each word, so "DIESEL | PETROL" and "diesel | petrol" both
// come out "Diesel | Petrol" regardless of how the API cased it. Splits on
// whitespace/underscore/hyphen, so don't pass a lone "-" placeholder value
// through this (it strips to "") — guard for that at the call site instead.
export const toTitleCase = (str) =>
  str
    .toLowerCase()
    .split(/[\s_-]+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

// Single source of truth for the `StatusBadge` component's color + label —
// pass any raw status value (string/number) from any list page and get
// back a consistent { bg, color, dot, label }. Unknown/empty values render
// as a neutral gray "-" badge rather than throwing or looking broken.
export const getStatusTheme = (rawValue) => {
  const raw =
    rawValue === null || rawValue === undefined ? "" : String(rawValue).trim();
  const normalized = raw.toLowerCase();

  if (!normalized) {
    return { ...STATUS_THEME_FAMILIES.gray, label: "-" };
  }

  const label = toTitleCase(raw);
  const exactFamily = STATUS_THEME_EXACT[normalized];
  if (exactFamily) {
    return { ...STATUS_THEME_FAMILIES[exactFamily], label };
  }

  const matchedRule = STATUS_THEME_KEYWORD_RULES.find((rule) =>
    rule.keywords.some((keyword) => normalized.includes(keyword)),
  );
  if (matchedRule) {
    return { ...STATUS_THEME_FAMILIES[matchedRule.family], label };
  }

  return { ...STATUS_THEME_FAMILIES.gray, label };
};

export const getStatusActions = (status) =>
  STATUS_ACTIONS[status] || DEFAULT_ACTIONS;

export const isActionAllowed = (status, action) =>
  Boolean(getStatusActions(status)[action]);

export const convertNumberToWords = (num) => {
  if (!num || num === 0) return "";

  const ones = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
  const teens = ["Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
  const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

  function convertTwoDigits(n) {
    if (n === 0) return "";
    if (n < 10) return ones[n];
    if (n < 20) return teens[n - 10];
    return tens[Math.floor(n / 10)] + (n % 10 > 0 ? " " + ones[n % 10] : "");
  }

  function convertThreeDigits(n) {
    if (n === 0) return "";
    let result = "";
    const hundred = Math.floor(n / 100);
    if (hundred > 0) {
      result += ones[hundred] + " Hundred";
    }
    const remainder = n % 100;
    if (remainder > 0) {
      if (result) result += " ";
      result += convertTwoDigits(remainder);
    }
    return result.trim();
  }

  const absNum = Math.abs(Math.floor(num));
  const crore = Math.floor(absNum / 10000000);
  const lakh = Math.floor((absNum % 10000000) / 100000);
  const thousand = Math.floor((absNum % 100000) / 1000);
  const remainder = absNum % 1000;

  let parts = [];

  if (crore > 0) {
    parts.push(convertThreeDigits(crore) + " Crore");
  }
  if (lakh > 0) {
    parts.push(convertTwoDigits(lakh) + " Lakh");
  }
  if (thousand > 0) {
    parts.push(convertTwoDigits(thousand) + " Thousand");
  }
  if (remainder > 0) {
    parts.push(convertThreeDigits(remainder));
  }

  return parts.join(" ").trim();
};
